import { ContactHelper } from '..';

export const useContact = () => {
	let contactHelper = new ContactHelper();
	return {
		contactHelper,
		activeContact: contactHelper.active()
	};
};
